module.exports = __webpack_public_path__ + "media/images/nastaveni-e204621f42c23628b8d7d8966cbc2d7d.png";